import { createFileRoute } from "@tanstack/react-router";
import { PasswordScreen } from "@/components/auth/password-screen";
export const Route = createFileRoute("/auth/forgot-password")({
  component: () => <PasswordScreen />,
});
